import { render, staticRenderFns } from "./beneficiary-bt-beneficiary-type.vue?vue&type=template&id=2c19beb5&"
import script from "./beneficiary-bt-beneficiary-type.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bt-beneficiary-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports